<div class="default-dialog-layout">
    <div class="title">{{ data.title }}</div>

    <ng-container *ngIf="data.warning">
        <div class="content">
            <cds-alert-group status="warning" type="light">
                <cds-alert>{{ data.warning }}</cds-alert>
            </cds-alert-group>
        </div>
    </ng-container>

    <ng-container *ngIf="data.item">
        <div class="content item">{{ data.item }}</div>
    </ng-container>

    <div class="actions action-buttons">
        <cds-button size="sm" action="flat" (click)="onCancel()">
            {{ data.cancelButtonLabel || 'Cancel' }}
        </cds-button>
        <cds-button size="sm" (click)="onConfirm()">
            {{ data.confirmButtonLabel || 'Confirm' }}
        </cds-button>
    </div>
</div>
